/* eslint-disable @typescript-eslint/no-explicit-any */
import type { GatsbyBrowser } from 'gatsby';
import { DefaultLayout } from 'layouts/DefaultLayout';
import { LayoutProvider } from 'layouts/LayoutProvider';
import { cloneElement } from 'react';

export const wrapRootElement: GatsbyBrowser['wrapRootElement'] = ({ element }) => {
    return <LayoutProvider>{element}</LayoutProvider>;
};

export const wrapPageElement: GatsbyBrowser['wrapPageElement'] = ({ element, props }) => {
    if ((element.type as any).Layout === false) {
        return cloneElement(element, props);
    }
    const Layout = (element.type as any).Layout ?? DefaultLayout;
    return <Layout {...props}>{element}</Layout>;
};

export const onRouteUpdate: GatsbyBrowser['onRouteUpdate'] = ({ location, prevLocation }) => {
    if (location.pathname === '/patient-resources/cherry-payment-plans/' && prevLocation) {
        setTimeout(() => {
            const widgetContainer = document.getElementById('all');
            if (widgetContainer && !widgetContainer.children.length) window.location.reload();
        }, 200);
    }
};
